import { render, staticRenderFns } from "./TipoEstadoConservacaoList.vue?vue&type=template&id=1e07ab5a"
import script from "./TipoEstadoConservacaoList.vue?vue&type=script&lang=js"
export * from "./TipoEstadoConservacaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports